<template>
  <div>
    <vs-popup class="sales-quote-email-log-popup"
              id="popup"
              :title='`SENT SAMPLE SPEC EMAIL LOG - ${order_code}`'
              :active.sync="open"
              :buttons-hidden="true">
      <vx-card no-shadow >

            <vs-table class="my-8" hoverFlat id="quote_item_table" :data="email_log" stripe>
              <template slot="thead">
                <vs-th>DATE/TIME</vs-th>
                <vs-th>STAFF USER (SENT BY)</vs-th>
                <vs-th>CUSTOMER USERS (SENT TO)</vs-th>
                <vs-th>PRODUCT SPECS SENT</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr"
                       v-for="(tr_item, indextr) in data">

                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].created_by_staff_name || 'N/A' }}
                  </vs-td>
                  <vs-td>
                   {{ data[indextr].data.users.toString() }}
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].data.formulations.toString() }}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
        <div v-if="is_on_send_mode" class="flex flex-wrap items-center justify-end mt-8">
          <vs-button @click.stop="onClickResendEmail" class="ml-auto mt-2">Resend</vs-button>
          <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
        </div>

      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const CustomerRepository = RepositoryFactory.get('customer')
import ErrorMessages from "@/mixins/ErrorMessages";
import successMessage from "@/mixins/SuccessMessage";

export default {
  name: "ViewSampleSpecEmailLogPopUp",
  data() {
    return {
      email_log: [],
      open: false,
      order_code: '',
      sample_order_id: '',
    }
  },
  mixins: [ ErrorMessages, successMessage],
  methods:{
    async openPopup(sample_order_id, order_code) {
      this.sample_order_id = sample_order_id
      this.order_code = order_code
      await this.fetchEmailLog()
      this.open = true
    },
    async fetchEmailLog() {
      const { data } = (await CustomerRepository.getSpecSendEmailLog(this.sample_order_id)).data
      this.email_log = data
    }
  }
}
</script>

<style scoped>

.sales-quote-email-log-popup >>> .vs-popup {
  min-width: 50% !important;
}
.label {

}

</style>
